<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="3">
                <DatePicker
                    :label="$t('entry_date')"
                    v-model="form.created_at"
                    outlined
                    dense
                    hide-details="auto"
                    disabled/>
            </v-col>
            <v-col cols="3">
                <DatePicker
                    :label="$t('document_date')"
                    v-model="form.date"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"/>
            </v-col>
            <v-col cols="3">
                <v-text-field
                    :label="$t('reference')"
                    v-model="form.reference"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <!-- <v-row align="center">
            <v-col>
                <v-text-field
                    dense
                    background-color="secondary"
                    ref="barcode"
                    :placeholder="$t('scan_barcode_here')"
                    persistent-placeholder
                    v-model="barcode"
                    :loading="barcodeLoading"
                    solo
                    prepend-inner-icon="mdi-barcode"
                    hide-details="auto"
                    @keypress.enter="handleBarcodeScan">
                    </v-text-field>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col>
                <!-- <div style="max-height:280px; overflow-y: auto;" ref="lineContainer"> -->
                    <GoodIssueVoucherFormLine
                        v-for="(line, index) in form.lines"
                        :key="line.key"
                        class="mb-1"
                        :items="items"
                        :accounts="accounts"
                        :dimensions="dimensions"
                        :warehouseId="warehouseId"
                        :documentDate="form.date"
                        :index="index"
                        v-model="form.lines[index]"
                        @update:item-search-input="searchItemsAsync"
                        @update:account-search-input="searchAccountsAsync"
                        @update:dimension-search-input="searchDimensionsAsync"
                        @delete:line="handleDeleteLine(index)"/>
                <!-- </div> -->
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn small depressed block @click="handleAddLine">
                    <v-icon left>mdi-format-line-spacing</v-icon>
                    add line
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-textarea
                    :label="$t('remarks')"
                    v-model="form.remarks"
                    :rules="[isRequired]"
                    outlined
                    dense
                    rows="4"
                    hide-details="auto">
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import DatePicker from './../common/DatePicker.vue';
import GoodIssueVoucherFormLine from './GoodIssueVoucherFormLine.vue';
import itemAPI from './../../services/stockJournal/Item';
import accountAPI from './../../services/stockJournal/account';
import dimensionAPI from './../../services/stockJournal/dimension'
import moment from 'moment';
import { randomSix } from '../../utils/toolkit';
import { isRequired } from './../../utils/validations';

export default {
    components: {
        DatePicker,
        GoodIssueVoucherFormLine
    },
    props: {
        value: Object,
        warehouseId: [Number, String]
    },
    data() {
        return {
            form: {
                id: null,
                created_at: moment().format("YYYY-MM-DD"),
                date: moment().format("YYYY-MM-DD"),
                warehouse_id: null,
                reference: null,
                remarks: null,
                lines: []
            },
            items: [],
            itemsLoading: false,
            accounts: [],
            accountsLoading: false,
            dimensions: [],
            dimensionsLoading: false,
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form, warehouse_id: this.warehouseId, lines: [...form.lines]})
            }
        }
    },
    methods: {
        isRequired,
        searchItemsAsync(query) {
            this.itemsLoading = true;
            itemAPI.search(query).then(response => {
                this.items = Array.from(new Set([...this.items, ...response.data]))
            }).finally(() => {
                this.itemsLoading = false;
            })
        },
        searchAccountsAsync(query) {
            this.accountsLoading = true;
            accountAPI.search(query).then(response => {
                this.accounts = Array.from(new Set([...this.accounts, ...response.data]))
            }).finally(() => {
                this.accountsLoading = false;
            })
        },
        searchDimensionsAsync(query) {
            this.dimensionsLoading = true;
            dimensionAPI.search(query).then(response => {
                this.dimensions = Array.from(new Set([...this.dimensions, ...response.data]))
            }).finally(() => {
                this.dimensionsLoading = false;
            })
        },
        handleDeleteLine(index) {
            this.form.lines.splice(index, 1)
        },
        handleAddLine() {
            this.form.lines.push({
                item_id: null,
                quantity: null,
                base_quantity: null,
                measure_unit_id: null,
                unit_value: null,
                value: null,
                account_id: null,
                dimension_id: null,
                available_quantity: null,
                key: randomSix()
            })
        },
        validate() {
            return this.$refs.form.validate();
        }
    },
    created() {
        this.handleAddLine();
        if(this.value) {
            this.form = {...this.value, lines: [...this.value.lines]};
            let lines = this.value.lines;
            if(Array.isArray(lines)) {
                lines.forEach(line => {
                    if(line.item) {
                        this.items = [...this.items, line.item]
                    }
                    if(line.account) {
                        this.accounts = [...this.accounts, line.account]
                    }
                    if(line.dimension) {
                        this.dimensions = [...this.dimensions, line.dimension]
                    }
                })
            }
        }
    }
}
</script>

<style>

</style>